import { Calendar } from '@fullcalendar/core';
import { getView } from './getView';
import { getCalendarOptions } from './calendarOptions';
import { CalendarFilterManager } from './FilterManager/agendaFilterManager';
import { luscinia } from '../luscinia';

const agendaEl = document.getElementById('luscinia-agenda') as HTMLDivElement;
if (agendaEl !== null) {
    const calendar = new Calendar(agendaEl, getCalendarOptions(agendaEl));
    calendar.setOption('windowResize', function (info) {
        calendar.changeView(getView(window.innerWidth));
    });

    var startDate;
    var endDate;
    var newSaved;
    var newSavedId;
    calendar.setOption('datesSet', function (dateInfo) {
        startDate = dateInfo.startStr;
        endDate = dateInfo.endStr;
        const detail = {
            start: startDate,
            end: endDate
        };
        const event = new CustomEvent('viewDatesChanged', { detail });
        document.dispatchEvent(event);
    });
    calendar.setOption('eventsSet', function (agendaEvents) {
        if (agendaEvents.length != 0) {
            const event = new CustomEvent('agendaEventsSet');
            document.dispatchEvent(event);

            if (newSaved) {
                var eventAdded = agendaEvents.find(x => x.id == newSavedId)
                if (eventAdded != undefined) {
                    const detail = {
                        start: eventAdded.startStr,
                        end: eventAdded.endStr
                    };
                    const eventDate = new CustomEvent('eventAdded', { detail });
                    document.dispatchEvent(eventDate);
                }
                newSaved = false;
            }
        }
    });

    if (luscinia.isMachineTestEnvironment()) {
        // Fetch the current date from the backend
        fetch('/test/current-date')
            .then(response => response.json())
            .then(data => {
                if (data.currentTime) {
                    const currentDate = new Date(data.currentTime);

                    // Update the current date highlight (now)
                    calendar.setOption('now', currentDate);

                    // Navigate to the current date
                    calendar.gotoDate(currentDate);
                }
            })
            .catch(error => {
                console.error('Error fetching current date:', error);
            });
    }

    calendar.setOption('eventChange', function (agendaEvents) {
        var oldEventStarDate = agendaEvents.oldEvent.startStr;
        var oldEventEndDate = agendaEvents.oldEvent.endStr;
        var newEventStarDate = agendaEvents.event.startStr;
        var newEventEndDate = agendaEvents.event.endStr;
        var eveid = agendaEvents.event.id;
        var eventf = agendaEvents.event;

        const detail = {
            oldEventStarDate: oldEventStarDate,
            oldEventEndDate: oldEventEndDate,
            newEventStarDate: newEventStarDate,
            newEventEndDate: newEventEndDate,
            eveid: eveid,
            event: eventf
        };

        const event = new CustomEvent('eventChange', { detail });
        document.dispatchEvent(event);
    });

    document.addEventListener('changeAgendaDuration', function (event: Event) {
        const customEvent = event as CustomEvent<any>;
        const newDuration = parseInt(customEvent.detail.agendaDuration);
        changeSlotDuration(newDuration);
    });

    document.addEventListener('changeAgendaTime', function (event: Event) {
        const customEvent = event as CustomEvent<any>;
        const minTime = customEvent.detail.minTime;
        const maxTime = customEvent.detail.maxTime;
        calendar.setOption('slotMinTime', minTime);
        calendar.setOption('slotMaxTime', maxTime);
    });

    function changeSlotDuration(newDuration) {
        calendar.setOption('slotDuration', { minute: newDuration });
    }
    document.addEventListener('viewDates', function (event) {
        const detail = {
            start: startDate,
            end: endDate
        };
        const eventDate = new CustomEvent('viewDatesChanged', { detail });
        document.dispatchEvent(eventDate);
    });

    document.addEventListener('refetchEvents', function (event) {
        calendar.refetchEvents();
    });

    document.addEventListener('refetchAll', function (event) {
        calendar.refetchEvents();
        calendar.render();
        calendar.updateSize();
    });

    calendar.render();

    ['recordDeleted', 'recordSaved'].forEach((eventName) => {
        document.addEventListener(eventName, (event) => {
            const customEvent = event as CustomEvent;
            if (event.type == "recordDeleted") {
                var events = calendar.getEvents();
                var deletedEventId = customEvent.detail.id;
                var deletedEvent = events.find(x => x.id == deletedEventId)
                const detail = {
                    start: deletedEvent.startStr,
                    end: deletedEvent.endStr
                };
                const eventDate = new CustomEvent('eventDeleted', { detail });
                document.dispatchEvent(eventDate);
                calendar.refetchEvents();
            }
            else {
                newSaved = true;
                newSavedId = customEvent.detail.id;
                calendar.refetchEvents();
            }
        });
    });

    const filterContainer = document.getElementById('filter-container');
    if (filterContainer != null) {
        const filterManager = new CalendarFilterManager(filterContainer, calendar);
        filterManager.init();
    }
}
